import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import ResetPasswordLink from "./pages/ResetPasswordLink";
import Register from "./pages/Register";
import Error404 from "./pages/Error404";
import ForbiddenPermits from "./pages/ForbiddenPermits";
import SuspendedAccount from "./pages/SuspendedAccount";
import CheckSession from "./pages/CheckSession";
import AllNotifications from "./pages/AllNotifications";
import AddUsers from "./pages/AddUsers";
import CompletaRegistro from "./pages/CompletaRegistro";
import Catalogo from "./pages/Catalogo";
import CatalogoAdmin from "./pages/CatalogoAdmin";
import Consumo from "./pages/Consumo";
import Profile from "./pages/Profile";
import Dashboard from "./pages/Dashboard";
import EpnoPartnos from "./pages/EpnoPartnos";
import FinanzasC from "./pages/FinanzasC";
import FinanzasS from "./pages/FinanzasS";
import GeneralServices from "./pages/GeneralServices";
import MyOrder from "./pages/MyOrder";
import MyThings from "./pages/MyThings";
import ListMyPackagesDetails from "./pages/ListMyPackagesDetails";
import OrderDetails from "./pages/OrderDetails";
import ComplaintDetails from "./pages/ComplaintDetails";
import Parts from "./pages/Parts";
import PendingPartNos from "./pages/PendingPartNos";
import ProductById from "./pages/ProductById";
import RangeMarket from "./pages/RangeMarket";
import Reviews from "./pages/Reviews";
import SeguimientoOrdenes from "./pages/SeguimientoOrdenes";
import ShowProductsByCategory from "./pages/ShowProductsByCategory";
import Solicitudes from "./pages/Solicitudes";
import SolicitudSoftware from "./pages/SolicitudSoftware";
import Users from "./pages/Users";
import Ventas from "./pages/Ventas";
import PendingVerification from "./pages/PendingVerification";
import SeguimientoQuejas from "./pages/SeguimientoQuejas";
import GetMerchant from "./pages/Merchants/GET";
import NewMerchant from "./pages/Merchants/POST";
import store from "./store";
import { Provider } from "react-redux";
import RegisterConfirmPage from "./pages/RegisterConfirm/RegisterConfirm";
import NewOrderDetails from "./pages/NewOrderDetails";
import MarketplaceHomePage from "./pages/Marketplace";
import Supplier from "./pages/Marketplace/Supplier";
import AllSuppliers from "./pages/Marketplace/supplier/AllSupliers";
import SupplierProducts from "./pages/Marketplace/industry/SupplierProducts";
import ShoppingCart from "./pages/Marketplace/global_components/ShoppingCart";
import CheckoutPage from "./pages/Marketplace/purchase/CheckoutPage";
import PurchaseOrders from "./pages/Marketplace/orders/PurchaseOrders";
import OrdersDetails from "./pages/Marketplace/orders/OrdersDetails";
import SupplierAllProducts from "./pages/Marketplace/supplier/AllProducts";
import SupplierAnalytics from "./pages/Marketplace/supplier/Analytics";
import MarketingMarketplace from "./pages/Marketing/Marketplace";
import MarketingEspeciales from "./pages/Marketing/Especiales";
import OrdersExpress from "./pages/OrdersExpress/OrderExpress";
import FinishedOrdersPage from "./pages/Orders/FinishedOrdersPage";
import CanceledOrdesPage from "./pages/Orders/CanceledOrdersPage";
import QuoteOrdesPage from "./pages/Orders/QuoteOrdersPage";
import BuildOrdesPage from "./pages/Orders/BuildOrdersPage";
import TogoOrdesPage from "./pages/Orders/TogoOrdersPage";
import ReviewOrdesPage from "./pages/Orders/ReviewOrdersPage";
import AproveOrdersPage from "./pages/Orders/AproveOrdersPage";
import MarketplaceRouter from "./pages/Marketplace/MarketplaceRouter";
import CategoryManager from "./pages/Marketplace/categoryAdmin/categoriesAdmin";
import Products from "./pages/Marketplace/Products";
import FilteredProducts from "./pages/Marketplace/global_components/filteredProducts";
import AdminClientes from "./pages/AdminUsers/AdminClientes";
import ThankYouPage from "./pages/Marketplace/global_components/ThankYouPage";
import OpenPayProvider from "./pages/Marketplace/global_components/OpenPayProvider";
import ThreeDSecureCallback from "./pages/Marketplace/global_components/ThreeDSecureCallback";
import ProductValidation from "./pages/Marketplace/admin/ProductValidation";
import SupplierList from "./pages/Suppliers/SupplierList";
import AccountList from "./pages/Financial/accountsList";
import ExpensesList from "./pages/Financial/expensesList";




function App() {
  return (
    <Provider store={store}>
      <OpenPayProvider>
        <Router future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}>
          <Routes>
            {/* RUTAS PÚBLICAS */}
            <Route path="" element={<MarketplaceHomePage />} />
            <Route path="/" element={<MarketplaceHomePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register/confirm" element={<RegisterConfirmPage />} />
            <Route path="reset">
              <Route path="password/:tokenUrl" element={<ResetPassword />} />
              <Route path="" element={<ResetPasswordLink />} />
            </Route>
            <Route path="error">
              <Route path="401" element={<ForbiddenPermits />} />
              <Route path="404" element={<Error404 />} />
            </Route>
            <Route path="/check-session" element={<CheckSession />} />

            {/* RUTAS DE MERCHANTS */}
            <Route path="merchants">
              <Route path=":id" element={<GetMerchant />} />
              <Route path="new" element={<NewMerchant />} />
            </Route>

            <Route path="suppliers" element={<SupplierList />} />
            <Route path="accounts" element={<AccountList />} />
            <Route path="expenses" element={<ExpensesList />} />

            {/* RUTAS PRINCIPALES */}
            <Route path="/@a-@n" element={<AllNotifications />} />
            <Route path="/@a-@u" element={<AddUsers />} />
            <Route path="/@c-@r/:role" element={<CompletaRegistro />} />
            <Route path="/catalog" element={<Catalogo />} />
            <Route path="/@c-@a" element={<CatalogoAdmin />} />
            <Route path="/@cns" element={<Consumo />} />
            <Route path="/@p/:id" element={<Profile />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/@e-@p" element={<EpnoPartnos />} />
            <Route path="/@f-@c" element={<FinanzasC />} />
            <Route path="/@f-@s" element={<FinanzasS />} />
            <Route path="/@m-@o" element={<MyOrder />} />
            <Route path="/@m-@t" element={<MyThings />} />
            <Route path="/@m-@p/:id" element={<ListMyPackagesDetails />} />
            <Route path="/@q-@d/:id" element={<ComplaintDetails />} />
            <Route path="/@p" element={<Parts />} />
            <Route path="/@p-@p" element={<PendingPartNos />} />
            <Route path="/@p-@d/:id/:category" element={<ProductById />} />
            <Route path="/@m" element={<RangeMarket />} />
            <Route path="/@rev" element={<Reviews />} />

            {/* RUTAS DE ÓRDENES */}
            <Route path="orders">
              <Route path="all/:type" element={<SeguimientoOrdenes />} />
              <Route path="details/:id" element={<OrderDetails />} />
              <Route path="details/new/:id" element={<NewOrderDetails />} />
              <Route path="request" element={<GeneralServices />} />
              <Route path="express" element={<OrdersExpress />} />
              <Route path="finished" element={<FinishedOrdersPage />} />
              <Route path="canceled" element={<CanceledOrdesPage />} />
              <Route path="quote" element={<QuoteOrdesPage />} />
              <Route path="build" element={<BuildOrdesPage />} />
              <Route path="togo" element={<TogoOrdesPage />} />
              <Route path="review" element={<ReviewOrdesPage />} />
              <Route path="aprove" element={<AproveOrdersPage />} />
            </Route>

            <Route path="suppliers" element={<SupplierList />} />




            {/* RUTAS DE PRODUCTOS */}
            <Route path="products/all" element={<GeneralServices />} />

            <Route path="/@q" element={<SeguimientoQuejas />} />
            <Route path="/@c-@p/:category" element={<ShowProductsByCategory />} />
            <Route path="/@s" element={<Solicitudes />} />
            <Route path="/@s-@s" element={<SolicitudSoftware />} />
            <Route path="/@u" element={<Users />} />
            <Route path="/@v" element={<Ventas />} />

            {/* RUTAS DE CUENTA */}
            <Route path="account">
              <Route path="unverified" element={<PendingVerification />} />
              <Route path="suspended" element={<SuspendedAccount />} />
            </Route>

            {/* MARKETPLACE PAGES */}
            <Route path="/marketplace" element={<MarketplaceHomePage />} />
            <Route path="/marketplace/thank-you" element={<ThankYouPage />} />
            <Route path="/marketplace/orders" element={<PurchaseOrders />} />
            <Route path="/marketplace/error404" element={<Error404 />} />
            <Route path="/marketplace/orders/details/:id" element={<OrdersDetails />} />
            <Route path="/marketplace/shopping-cart" element={<ShoppingCart />} />
            <Route path="/marketplace/checkout" element={<CheckoutPage />} />
            <Route path="/marketplace/admin/categories" element={<CategoryManager />} />
            <Route path="/marketplace/admin/product-validation" element={<ProductValidation />} />
            <Route path="/marketplace/:category?/:catalog?/:productId" element={<Products />} />
            <Route path="/marketplace/suppliers" element={<AllSuppliers />} />
            <Route path="/marketplace/suppliers/:supplier_id" element={<Supplier />} />
            <Route path="/marketplace/suppliers/:supplier/all-products" element={<SupplierProducts />} />
            <Route path="/marketplace/products/filter" element={<FilteredProducts />} />
            <Route path="/marketplace/checkout/3d-secure-response" element={<ThreeDSecureCallback />} />

            {/* SUPPLIER & ADMIN RUTAS ESPECÍFICAS */}
            <Route path="/marketplace/:user/all-products" element={<SupplierAllProducts />} />
            <Route path="/marketplace/:user/orders" element={<PurchaseOrders />} />
            <Route path="/marketplace/:user/analytics" element={<SupplierAnalytics />} />
            <Route path="/marketplace/:user/orders/details/:id" element={<OrdersDetails />} />

            {/* MARKETING ROUTES */}
            <Route path="/marketing/marketplace" element={<MarketingMarketplace />} />
            <Route path="/marketing/especiales" element={<MarketingEspeciales />} />

            {/* RUTA DE ADMINISTRACIÓN DE CLIENTES */}
            <Route path="/@a-@c" element={<AdminClientes />} />


            <Route path="/marketplace/*" element={<MarketplaceRouter />} />

          </Routes>
        </Router>
      </OpenPayProvider>
    </Provider>
  );
}

export default App;